import { Component } from '@verndale/core';
import _debounce from 'lodash/debounce';
import { nanoid } from 'nanoid';

import { nextFrameAsync } from '../utils/timedEvents';

export default class TwoColumnAccordion extends Component {
  setupDefaults() {
    this.dom = {
      accordionItems: this.el._$$('.accordion__block'),
      column: this.el._$('.accordion__column'),
      accordion: this.el._$('.accordion__accordion')
    };

    this.divideItems();
    this.handleResize();
  }

  addListeners() {
    window.addEventListener('resize', ::this.handleResize);
  }

  async handleResize() {
    const $headings = this.el._$$('.accordion__tab-heading');

    $headings.forEach(($heading) => {
      const $button = $heading._$('.accordion__tab-heading-button');
      $heading.style.removeProperty('min-height');
      $button.style.removeProperty('min-height');
    });

    await nextFrameAsync();

    const maxHeight = Math.max(...$headings.map((h) => h.offsetHeight));

    $headings.forEach(($heading) => {
      const $button = $heading._$('.accordion__tab-heading-button');
      $heading.style.minHeight = `${maxHeight}px`;
      $button.style.minHeight = `${maxHeight}px`;
    });
  }

  divideItems() {
    const secondColumn = this.createSecondColumn();

    this.dom.accordionItems
      .filter((_, index) => index % 2 === 1)
      .forEach(($item) => {
        const $newItem = $item.cloneNode(true);
        this.setAriaAtributes($newItem);
        secondColumn.appendChild($newItem);
      });
  }

  createSecondColumn() {
    const newColumn = document.createElement('div');
    newColumn.classList.add('accordion__column');
    this.dom.column.parentNode.appendChild(newColumn);
    return newColumn;
  }

  setAriaAtributes($element) {
    const $button = $element._$('.accordion__tab-heading-button');
    const $sectionContent = $element._$('.accordion__tab-content');
    const buttonId = `id-${nanoid()}`;
    const sectionContentId = `id-${nanoid()}`;

    $button.id = buttonId;
    $button.setAttribute('aria-controls', sectionContentId);
    $sectionContent.id = sectionContentId;
    $sectionContent.setAttribute('aria-labelledby', buttonId);
  }
}
